/* istanbul ignore next */
export function body() {
	return typeof document !== 'undefined' && document.body ? document.body : {};
}

/* istanbul ignore next */
export function scrollingElement() {
	return typeof document !== 'undefined' && document.scrollingElement
		? document.scrollingElement
		: body();
}

/* istanbul ignore next */
export function querySelector(selector) {
	return typeof document !== 'undefined' && document.querySelector
		? document.querySelector(selector)
		: null;
}

/* istanbul ignore next */
export function querySelectorAll(selector) {
	return typeof document !== 'undefined' && document.querySelectorAll
		? document.querySelectorAll(selector)
		: null;
}

/* istanbul ignore next */
export function getElementById(id) {
	return typeof document !== 'undefined' && document.getElementById
		? document.getElementById(id)
		: null;
}

/* istanbul ignore next */
export function createElement(el) {
	return typeof document !== 'undefined' && document.createElement
		? document.createElement(el)
		: null;
}

/* istanbul ignore next */
export function addEventListener(event, func) {
	return typeof document !== 'undefined' && document.addEventListener
		? document.addEventListener(event, func)
		: null;
}

/* istanbul ignore next */
export function removeEventListener(event, func) {
	return typeof document !== 'undefined' && document.removeEventListener
		? document.removeEventListener(event, func)
		: null;
}
